import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import { ButtonV3 } from '@zola/zola-ui/src/components/ButtonV3';
import { Link } from '@zola/zola-ui/src/components/Link';
import './BrandGrid.less';

export default function BrandGrid({ categoryTitle, items, categoryKey, redesign = false }) {
  const renderBrands = () =>
    items.map(({ key, brand_logo: imgSrc, name }) => (
      <div key={key} className="brand-grid__brand">
        <a href={`/shop/brand/${key}`} className="brand-grid__link">
          <img className="brand-grid__img" src={imgSrc} alt={name} />
        </a>
      </div>
    ));

  return (
    <div className={cx('brand-grid', { redesign })}>
      <div className="wrapper-content">
        {!redesign && <h2 className="brand-grid__title">Top {categoryTitle} Brands</h2>}
        <div className="brand-grid__row">
          {renderBrands()}
          {redesign && (
            <div className="description__link">
              <ButtonV3 component="a" href={`/shop/brands/${categoryKey}`}>
                Shop all brands
              </ButtonV3>
            </div>
          )}
        </div>
        {!redesign && (
          <Link href={`/shop/brands/${categoryKey}`} className="description__link">
            See all brands
          </Link>
        )}
      </div>
    </div>
  );
}

BrandGrid.propTypes = {
  redesign: PropTypes.bool,
  categoryTitle: PropTypes.string,
  categoryKey: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      brand_logo: PropTypes.string,
      key: PropTypes.string,
      name: PropTypes.string,
    })
  ),
};
